import { TSchema } from '@sinclair/typebox';

export function createOperation<
    const Parameters extends { name: string; in: 'query' | 'path'; schema: TSchema; required?: true }[],
    const ResponseSchema extends TSchema,
>(operationId: string, parameters: Parameters, responseSchema: ResponseSchema) {
    return {
        operationId,
        parameters,
        responses: {
            '200': {
                description: 'Result of the operation',
                content: {
                    'application/json': {
                        schema: responseSchema,
                    },
                },
            },
        },
    } as const;
}

export function createOperationWithBody<
    const Parameters extends { name: string; in: 'query' | 'path'; schema: TSchema; required?: true }[],
    const ResponseSchema extends TSchema,
    const RequestBodySchema extends TSchema,
>(operationId: string, parameters: Parameters, responseSchema: ResponseSchema, requestBodySchema: RequestBodySchema) {
    return {
        operationId,
        parameters,
        responses: {
            '200': {
                description: 'Result of the operation',
                content: {
                    'application/json': {
                        schema: responseSchema,
                    },
                },
            },
        },
        requestBody: {
            content: {
                'application/json': {
                    schema: requestBodySchema,
                },
            },
        },
    } as const;
}
